var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05266 4.46447C2.66213 4.07394 2.66213 3.44078 3.05266 3.05025C5.78633 0.316582 10.2185 0.316583 12.9522 3.05025C15.6858 5.78392 15.6858 10.2161 12.9522 12.9497C10.2185 15.6834 5.78633 15.6834 3.05266 12.9497C2.66213 12.5592 2.66213 11.9261 3.05266 11.5355C3.44318 11.145 4.07635 11.145 4.46687 11.5355C6.41949 13.4882 9.58532 13.4882 11.5379 11.5355C13.4906 9.58291 13.4906 6.41709 11.5379 4.46447C9.58532 2.51184 6.41949 2.51184 4.46687 4.46447C4.07635 4.85499 3.44318 4.85499 3.05266 4.46447Z",
    fill: "#212D41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09104 5.41545C2.24899 5.75987 2.59682 5.99914 3.00048 5.9992C3.00215 5.9992 3.00382 5.9992 3.00548 5.99919L6 5.99967C6.55219 5.99976 6.99977 5.55218 6.99968 4.99999C6.99959 4.44779 6.55187 4.00008 5.99968 3.99999L4 3.99967L3.99968 2C3.99959 1.4478 3.55188 1.00009 2.99968 1C2.44748 0.999912 1.99991 1.44748 2 1.99968L2.00048 4.99623C2.00048 4.99722 2.00047 4.9982 2.00047 4.99919C2.00049 5.06821 2.0075 5.13562 2.02082 5.20071",
    fill: "#212D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.3cf397b9cf21b68990796d8e0eaea42e.svg";
export { ForwardRef as ReactComponent };